import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapFilterAddPageComponent from './mapFilterAddPage.component';

let mapFilterAddPageModule = angular.module('mapFilterAddPage', [
  uiRouter
])

.component('mapFilterAddPage', mapFilterAddPageComponent)

.name;

export default mapFilterAddPageModule;
